import { type LoaderFunctionArgs, redirect } from "react-router";
import { type Me, UnauthorizedError, fetchMe } from "./api";

export async function requireAuth({ request }: LoaderFunctionArgs): Promise<Me> {
  try {
    return await fetchMe(request.signal);
  } catch (err) {
    if (err instanceof UnauthorizedError) {
      const url = new URL(request.url);
      const returnTo = url.pathname + url.search;
      const loginUrl =
        returnTo === "/" ? "/login" : `/login?return_to=${encodeURIComponent(returnTo)}`;
      throw redirect(loginUrl);
    }
    throw err;
  }
}

export async function requireGuest({ request }: LoaderFunctionArgs): Promise<null> {
  try {
    await fetchMe(request.signal);
    // Already authenticated — bounce to the dashboard.
    throw redirect("/");
  } catch (err) {
    if (err instanceof UnauthorizedError) return null;
    throw err;
  }
}
